import { Link } from "react-router-dom";
import { MapPin } from "../../Atoms/Icons";
import { isNewJob, buildMailto } from "../../static/jobsHelpers";
import { getDepartmentLabel, getLocationLabel } from "../../static/filterOptions";

import { IoChevronForwardOutline } from "react-icons/io5";
import { BsArrowRightShort } from "react-icons/bs";

// One job listing card — used on both the Careers landing page
// ("Current Openings" preview) and the full Open Positions grid.
export default function JobCard({ job }) {
  return (
    <article className="job-card">
      <div className="flex flex-wrap gap-2 mb-3">
        <span className="badge-dept">{getDepartmentLabel(job.department)}</span>
        <span className="badge-type">{job.employmentTypeShort}</span>
        {isNewJob(job) && <span className="badge-new">New</span>}
      </div>

      <h3 className="text-lg font-bold mb-2 brand-font">{job.title}</h3>

      <p className="flex items-center gap-1 text-sm text-[var(--vm-text-gray)] mb-2">
        <MapPin size={14} />
        {getLocationLabel(job.location)}
      </p>

      <p className="text-[0.92rem] text-[var(--vm-text-gray)] mb-4">{job.teaser}</p>

      <div className="flex flex-wrap gap-2">
        <a href={buildMailto(job)} className="btn-brand text-sm px-4 py-3">
          Apply Now
        </a>
        <Link to={`/careers/${job.slug}`} className="btn-outline-brand text-sm px-4 py-2">
          View Details
        </Link>
        {/* <Link to={`/careers/${job.slug}`} className="text-gray-600">
  <button
    className="btn-new font-semibold relative flex justify-center items-center rounded-full pl-12 pr-6 font-poppins"
  >
    <span className="flex justify-center items-center">
      <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
      <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
    </span>
    View Details
  </button>
</Link> */}
      </div>
    </article>
  );
}
